import type { ButtonHTMLAttributes, Ref } from "react";
import { styled } from "@pigment-css/react";
import { DotsHorizontal } from "@acto/web-common/components";
import { OutlinedPillButton } from "@acto/taskpane/field-sales-2/components/primitives/OutlinedPillButton";

const Root = styled(OutlinedPillButton)(({ theme }) => ({
  flexShrink: 0,
  width: theme.fieldSalesTwo.spacing[50],
  padding: 0,
  border: `${theme.strokeWidth.thin} solid ${theme.fieldSalesTwo.colors.surface.glassBorderStrong}`,
  borderRadius: theme.fieldSalesTwo.radius[44],
  background: theme.fieldSalesTwo.colors.surface.glassLight,
  backdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  WebkitBackdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  // DotsHorizontal has a 13:3 viewBox; size width only (height auto) so it keeps its
  // aspect ratio instead of being squashed into a square.
  "& svg": {
    width: "18px",
    height: "auto",
  },
}));

interface MoreButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  "aria-label": string;
  ref?: Ref<HTMLButtonElement>;
}

export function MoreButton({ type = "button", ...rest }: MoreButtonProps) {
  return (
    <Root type={type} {...rest}>
      <DotsHorizontal />
    </Root>
  );
}
